import { HeadingElement, ResponsiveHeadingSizesType, HeadingSize } from '../Typography/types';

const SIZES: { [key: number]: HeadingSize } = {
    1: 'h_xxl',
    2: 'h_xl',
    3: 'h_lg',
    4: 'h_md',
    5: 'h_sm',
    6: 'h_xs',
    7: 'h_xxs',
};

export const getResponsiveObject = (as: HeadingElement): ResponsiveHeadingSizesType => {
    const size = Number(as.replace('h', ''));

    return {
        default: SIZES[size + 1],
        sm: SIZES[size],
    };
};
